import { render, staticRenderFns } from "./statsTable.vue?vue&type=template&id=3a0ba28d&scoped=true&class=TableSTatssss"
import script from "./statsTable.vue?vue&type=script&lang=js"
export * from "./statsTable.vue?vue&type=script&lang=js"
import style0 from "./statsTable.vue?vue&type=style&index=0&id=3a0ba28d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ba28d",
  null
  
)

export default component.exports